import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {AppSettings} from '../../../settings/app-settings';

@Injectable()
export class TStockLedgerService {

  constructor(private http: HttpClient) {
  }

  public getStockQtyByItemBarcodeAndBranch(itemBarcode: string): Observable<number> {
    return this.http.get<number>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/trasactions/t-stock-ledger/find-by-item-barcode-and-branch/' + itemBarcode);
  }

  public getStockQtyByItemBarcodeAndBranchAndStore(itemBarcode: string, branch: number, store: number): Observable<number> {
    return this.http.get<number>(AppSettings.API_ENDPOINT + '/api/v1/gflock-main-service/trasactions/t-stock-ledger/find-by-item-barcode-and-branch-and-store/' + itemBarcode + '/' + branch + '/' + store);
  }
}



// WEBPACK FOOTER //
// ./src/app/view/service/t-stock-ledger/service/t-stock-ledger.service.ts